import {
  useMemo,
  useState,
} from "react";
import DetailsGanttContext from "./DetailsGantt.context";

const DetailsGanttProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [event, setEvent] = useState<Sentinel.Timeline.Event>();

  const contextValue = useMemo(() => {
    const onClose = () => {
      setOpen(false);
      setEvent(undefined);
    };

    const onOpen = (event: Sentinel.Timeline.Event) => {
      setEvent(event);
      setOpen(true);
    };

    const onEventUpdate = (patch: Partial<Sentinel.Timeline.Event>) => {
      setEvent((prev) => prev ? { ...prev, ...patch } : prev);
    };

    return { open, event, onClose, onOpen, onEventUpdate };
  }, [open, event]);

  return (
    <DetailsGanttContext.Provider value={contextValue}>
      {children}
    </DetailsGanttContext.Provider>
  );
};

export default DetailsGanttProvider;
